import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import _ from 'lodash';

import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

import { TryRoundedIcon } from '../../../components/customStyles/images';

import { EMPTY_BOX_MESSAGE } from '../constants';

import useMediaQuery from '@mui/material/useMediaQuery';
import ChatList from './ChatList';
import { GptOutBox, GptInBox, ChatEmptyBox } from './chatbotStyle';
import theme from '../../../theme';


const GptMessage = ({ chatData, progress, scrollToBottom, gptBoxRef }) => {
  const isMoblie = useMediaQuery(theme.breakpoints.down('md'));

  return (
    <>
      <GptOutBox
        sx={{
          width: isMoblie ? '100%' : '60%',
          paddingLeft: isMoblie ? 0 : '24px',
          height: isMoblie ? 'calc(100vh - 180px)' : '76vh',
        }}
      >
        <GptInBox>
          {!chatData.length &&
            <ChatEmptyBox
              sx={{ height: isMoblie ? 'calc(100vh - 180px)' : '76vh', }}
            >
              <Box sx={{ textAlign: 'center' }}>
                <TryRoundedIcon sx={{ width: '120px', height: '120px', color: theme.palette.secondary.w200 }} />
                <Typography variant='h5'>{EMPTY_BOX_MESSAGE}</Typography>
              </Box>
            </ChatEmptyBox>
          }
          {chatData && chatData.length > 0 &&
            <ChatList
              chatData={chatData}
              progress={progress}
              scrollToBottom={scrollToBottom}
              gptBoxRef={gptBoxRef}
              isMoblie={isMoblie}
            />
          }
        </GptInBox>
      </GptOutBox>
    </>
  )
}

export default GptMessage;